var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.296 8.75 17.46 6.527c-1.452-.834-3.478-.834-4.919 0L8.707 8.76v-.813c0-2.437 1.333-3.78 3.77-3.78h5.049c2.437 0 3.77 1.343 3.77 3.78v.802z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.175 10.556-1.473-.845-3.055-1.765c-.932-.542-2.362-.542-3.294 0L10.298 9.7l-1.473.866-.195.098c-1.896 1.278-2.026 1.516-2.026 3.564v4.897c0 2.047.13 2.285 2.07 3.596l4.68 2.698c.465.281 1.05.4 1.646.4.585 0 1.18-.13 1.647-.4l4.723-2.73c1.907-1.279 2.026-1.506 2.026-3.564v-4.897c0-2.048-.13-2.286-2.07-3.597l-.151-.076zm-3.813 6.88a.784.784 0 0 0-.174.509l.065 1.04c.044.639-.411.964-1.007.736l-.964-.39a.96.96 0 0 0-.553 0l-.964.38c-.596.238-1.05-.098-1.007-.737l.064-1.04a.784.784 0 0 0-.173-.51l-.671-.8c-.412-.488-.228-1.03.39-1.193l1.007-.26a.873.873 0 0 0 .433-.325l.564-.866c.346-.542.899-.542 1.256 0l.564.866c.086.141.281.282.433.325l1.008.26c.617.163.801.705.39 1.192l-.661.813z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon-03.05ac70a582976f5376d7398ca76fd6e4.svg";
export { ForwardRef as ReactComponent };